// extracted by mini-css-extract-plugin
export default {"checkbox":"YiEb9","inactive":"mjWo3","title":"YZPgC","actions":"m1sIc","selected-text":"XN2Qg","selectedText":"XN2Qg","massEdit":"C3goI"};